import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { COLLAGE_IMAGES } from '@/constants/promotionImages';
import serverWarmupService from '@/services/serverWarmupService';

export function PromotionFlowLayout() {
  const location = useLocation();
  useEffect(() => { serverWarmupService.pingServer(); }, [location.pathname]);

  return (
    <>
      <div className="fixed inset-0 -z-10" aria-hidden="true">
        <div className="grid h-full w-full grid-cols-2 grid-rows-3 sm:grid-cols-3 sm:grid-rows-2">
          {COLLAGE_IMAGES.map((src) => (
            <div key={src} className="overflow-hidden">
              <img
                src={src}
                alt=""
                loading="eager"
                decoding="async"
                className="h-full w-full object-cover"
              />
            </div>
          ))}
        </div>
        <div className="absolute inset-0 bg-linear-to-br from-slate-900/55 via-slate-900/40 to-slate-900/65" />
      </div>
      <Outlet />
    </>
  );
}